<div class="ai-search">

  <div class="search-bar">

    <input
      type="text"
      [(ngModel)]="query"
      placeholder="Cerca amb AI..."
      (keyup.enter)="doSearch()"
    />

    <button (click)="doSearch()">
      Cercar
    </button>

    <button (click)="downloadCSV()">
      CSV
    </button>

  </div>

  <div *ngIf="loading">
    Cercant...
  </div>

  <table *ngIf="results.length > 0">

    <thead>
      <tr>
        <th>Coincidència</th>
<!--        <th>Tipus</th> -->
        <th>ID</th>
        <th>Títol</th>
        <th>Contingut</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let r of results">
        <td>
          <div
            class="badge"
            [ngClass]="getRelevanceClass(r.score)"
          >
            {{ getRelevanceLabel(r.score) }}
          </div>
        </td>
<!--        <td>
          {{ r.source_type }}
        </td>
-->
        <td>
          <a [routerLink]="r.link">
            {{ r.origen_id }}
          </a>
        </td>

        <td>
          {{ r.titol }}
        </td>

        <td class="content-cell">
          {{ r.contingut }}
        </td>
      </tr>
    </tbody>
  </table>
</div>